module.exports = __webpack_public_path__ + "static/media/samsung-awesome-is-for-everyone-2019.bd928359.jpg";